/**
 * Role permission helpers (frontend).
 * Keep in sync with backend/config/rolePermissions.js
 */

import { AM_MRO_INHERITED_ROLES, ROLES } from '../constants/roles';

export function isSpectator(role) {
  return role === ROLES.SPECTATOR;
}

export function hasSuperAdminView(role) {
  return role === ROLES.SUPER_ADMIN || role === ROLES.SPECTATOR;
}

export function canWrite(role) {
  return role !== ROLES.SPECTATOR;
}

/**
 * True when role is explicitly allowed, SPECTATOR when SUPER_ADMIN is allowed,
 * or AM_MRO when an inherited MRO / Planning / Store role is allowed.
 */
export function roleMatches(role, allowedRoles) {
  if (!role || !Array.isArray(allowedRoles) || allowedRoles.length === 0) {
    return false;
  }
  if (allowedRoles.includes(role)) {
    return true;
  }
  if (role === ROLES.SPECTATOR && allowedRoles.includes(ROLES.SUPER_ADMIN)) {
    return true;
  }
  if (role === ROLES.AM_MRO) {
    return allowedRoles.some((allowed) => AM_MRO_INHERITED_ROLES.includes(allowed));
  }
  return false;
}

/**
 * True when role may perform write actions for the given allowed roles.
 */
export function roleCanWrite(role, allowedRoles) {
  return canWrite(role) && allowedRoles.includes(role);
}
